// extracted by mini-css-extract-plugin
export var bodySections = "_40-8";
export var gray = "_40-7";
export var green = "_40-4";
export var iconContainer = "_40-9";
export var iconWidgetContainer = "_40-1";
export var phoneIcon = "_40-2";
export var red = "_40-5";
export var statusDot = "_40-3";
export var widgetContainer = "_40-0";
export var yellow = "_40-6";